export enum RespostaProcessamento {
  PROCESSADO = <any> 'PROCESSADO',
  IGNORADO = <any> 'IGNORADO',
  NAO_ENCONTRADA = <any> 'NAO_ENCONTRADA',
  FALHA = <any> 'FALHA'
}
